// --------------------------------------------------------------------------
// Mobile version togglable footer navigation
// --------------------------------------------------------------------------
// Author:      Lukasz Wolnik
// Email:       lukaszwolnik@rspb.org.uk
// URL:         http://www.rspb.org.uk
// Copyright:   Copyright (c) 2016, RSPB. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');
var debounce = require('../utilities/debounce');

module.exports = function (options) {
  var context = options.context,
      resizeHandler;

  function init() {
    resizeHandler();

    $(window).on('resize', debounce(resizeHandler, 250));
  }

  resizeHandler = function resizeHandler() {
    context.off('click', '[data-binding="footer-menu"]');
    context.find('[data-binding="footer-menu"]').removeClass('active');
    context.find('[data-binding="footer-list"]').removeClass('active').removeAttr('style');

    if (!context.find('[data-binding="footer-menu"]').next('[data-binding="footer-list"]').is(':visible')) {
      context.on('click', '[data-binding="footer-menu"]', function () {
        $(this).toggleClass('active');
        $(this).next('[data-binding="footer-list"]').toggle(0);
      });
    }
  };

  return {
    init: init
  };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/footer-navigation.js
// module id = 180
// module chunks = 0